import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const LOGO_URL = '/logo.PNG';

export default function ChangePIN() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('au_user') || '{}');
  const [form, setForm] = useState({ currentPin: '', newPin: '', confirmPin: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.newPin !== form.confirmPin) {
      setError('New PINs do not match.');
      return;
    }
    if (!form.newPin.match(/^\d{4,6}$/)) {
      setError('PIN must be 4–6 digits.');
      return;
    }
    setLoading(true);
    try {
      await api.patch('/auth/change-pin', { currentPin: form.currentPin, newPin: form.newPin });
      const updatedUser = { ...user, mustChangePIN: false };
      localStorage.setItem('au_user', JSON.stringify(updatedUser));
      navigate(user.role === 'owner' ? '/owner/dashboard' : '/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to change PIN.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card fu">
        <div className="login-logo-wrap">
          <img src={LOGO_URL} alt="Logo" className="login-logo-img" />
          <div className="login-brand">
            <span className="au-amravati">Amravati</span>
            <span className="au-urban"> Urban</span>
          </div>
        </div>

        <div style={{ marginBottom: '6px' }}>
          <div className="login-title" style={{ marginBottom: '4px' }}>Set Your PIN</div>
          <div style={{ fontSize: '12.5px', color: 'var(--g3)', textAlign: 'center', marginBottom: '20px' }}>
            Welcome, <strong style={{ color: 'var(--navy)' }}>{user.name}</strong>! Please set a new PIN before continuing.
          </div>
        </div>

        {error && <div className="error-msg" data-testid="change-pin-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Current PIN</label>
            <input
              className="form-input" type="password" placeholder="Enter current PIN"
              value={form.currentPin} onChange={e => setForm(p => ({ ...p, currentPin: e.target.value }))}
              inputMode="numeric" maxLength={6} required data-testid="current-pin-input"
            />
          </div>
          <div className="form-group">
            <label className="form-label">New PIN</label>
            <input
              className="form-input" type="password" placeholder="4–6 digit PIN"
              value={form.newPin} onChange={e => setForm(p => ({ ...p, newPin: e.target.value }))}
              inputMode="numeric" maxLength={6} required data-testid="new-pin-input"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm New PIN</label>
            <input
              className="form-input" type="password" placeholder="Re-enter new PIN"
              value={form.confirmPin} onChange={e => setForm(p => ({ ...p, confirmPin: e.target.value }))}
              inputMode="numeric" maxLength={6} required data-testid="confirm-pin-input"
            />
          </div>
          <button className="sub-btn" type="submit" disabled={loading} data-testid="change-pin-submit">
            {loading ? 'Saving…' : 'Set New PIN & Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
